import * as React from 'react'

import { Box, Chevron, Colors, Popover, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import TooltipHeader from 'modules/attendance/components/ClockIn/Tooltip/Header'
import TooltipRow from 'modules/attendance/components/ClockIn/Tooltip/Row'
import MinutesToText from 'modules/attendance/components/MinutesToText'

interface ComplementaryHoursData {
  complementaryHoursMinutes: number
  contractHoursMinutes: number
  plannedHoursMinutes: number
  workedHoursMinutes: number
  effectiveWorkedMinutes: number
}

interface ComplementaryHoursColumnProps {
  complementaryHoursData: ComplementaryHoursData
  grayedOutColor: Colors
  complementaryHoursBaseline: string | null | undefined
}

const ComplementaryHoursColumn = ({
  complementaryHoursData,
  grayedOutColor,
  complementaryHoursBaseline,
}: ComplementaryHoursColumnProps) => {
  const {
    complementaryHoursMinutes,
    contractHoursMinutes,
    plannedHoursMinutes,
    workedHoursMinutes,
  } = complementaryHoursData
  const { effectiveWorkedMinutes } = complementaryHoursData
  const [open, toggle] = useToggle(false)

  // Default to contract_hours if baseline is null/undefined
  const baseline = complementaryHoursBaseline ?? 'contract_hours'

  const baselineLabel =
    baseline === 'contract_hours'
      ? i18n.t('clock_in.complementary_hours.complementary_hours_column.agreement_hours')
      : i18n.t('clock_in.complementary_hours.complementary_hours_column.planned_hours')

  const baselineValue = baseline === 'contract_hours' ? contractHoursMinutes : plannedHoursMinutes

  const workedHoursLabel =
    baseline === 'contract_hours'
      ? i18n.t('clock_in.complementary_hours.complementary_hours_column.effective_worked_hours')
      : i18n.t('clock_in.complementary_hours.complementary_hours_column.worked_hours')

  const workedHoursValue =
    baseline === 'contract_hours' ? effectiveWorkedMinutes : workedHoursMinutes

  return (
    <Popover.ItemList attachment="bottom center" toggle={toggle} open={open} gapDivider={false}>
      <Box inline flexDirection="row" gap="s4" alignItems="center">
        <MinutesToText
          value={complementaryHoursMinutes}
          weight="medium"
          alwaysRemainder
          color={grayedOutColor}
        />
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </Box>
      <Box gap="s12" minWidth="s200">
        <TooltipHeader
          title={i18n.t('clock_in.complementary_hours.title')}
          minutes={complementaryHoursMinutes}
        />

        <TooltipRow label={baselineLabel} value={baselineValue} />

        <TooltipRow label={workedHoursLabel} value={workedHoursValue} />
      </Box>
    </Popover.ItemList>
  )
}

export default ComplementaryHoursColumn
